import { authService } from './authService';

const API_BASE_URL = 'https://apidashboard.teamgreekgods.ma/api';

export interface SearchResult {
  id: number;
  type: string;
  display_name: string;
  is_active?: boolean | number | string | null;
  was_activated?: boolean | number | string | null;
  [key: string]: any;
}

export interface SearchResults {
  clients: SearchResult[];
  employees: SearchResult[];
  subscriptions: SearchResult[];
  invoices: SearchResult[];
  payments: SearchResult[];
  stores: SearchResult[];
  todos: SearchResult[];
  checkins: SearchResult[];
  packs: SearchResult[];
  recaps: SearchResult[];
  auditLogs: SearchResult[];
  total: number;
}

export interface SearchResponse {
  success: boolean;
  data: SearchResults;
  query: string;
}

export const searchService = {
  /**
   * Perform global search across all database tables
   */
  globalSearch: async (
    query: string,
    options?: { scope?: 'primary' | 'full'; signal?: AbortSignal }
  ): Promise<SearchResponse> => {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        throw new Error('No authentication token found');
      }

      const scopeParam = options?.scope === 'primary' ? '&scope=primary' : '';
      const response = await fetch(
        `${API_BASE_URL}/search?q=${encodeURIComponent(query)}${scopeParam}`,
        {
        signal: options?.signal,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Search failed');
      }

      const data: SearchResponse = await response.json();
      return data;
    } catch (error) {
      console.error('Search error:', error);
      throw error;
    }
  }
};

